"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _IconButton = _interopRequireDefault(require("@eig-builder/core-ui/IconButton"));

var _Icon = _interopRequireDefault(require("@eig-builder/core-ui/Icon"));

var _iframeDetectionHelper = require("@eig-builder/core-utils/helpers/iframe-detection-helper");

var _taggingHelper = require("@eig-builder/core-utils/helpers/tagging-helper");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var dataElementPrefix = 'close-iframe-';

var CloseIframeButton = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(CloseIframeButton, _Component);

  var _super = _createSuper(CloseIframeButton);

  function CloseIframeButton() {
    var _this;

    (0, _classCallCheck2["default"])(this, CloseIframeButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      minimized: false
    };

    _this.sendEvent = function (eventName) {
      if (!(0, _iframeDetectionHelper.inIframe)() && eventName === 'close') {
        window.close();
        return;
      }

      if (eventName === 'minimize' || eventName === 'maximize') {
        _this.setState({
          minimized: eventName === 'minimize'
        });
      }

      if (window.parent) {
        window.parent.postMessage({
          type: 'help-widget-' + eventName
        }, '*');
      }
    };

    return _this;
  }

  (0, _createClass2["default"])(CloseIframeButton, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var minimized = this.state.minimized;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, !minimized && /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
        tag: "minimize-widget",
        dataElementLocation: _taggingHelper.DataElementLocations.HEADER,
        dataElementLabel: "".concat(dataElementPrefix, "minimize-widget"),
        dataElementId: "".concat(dataElementPrefix, "minimize-widget"),
        className: "minimize-widget",
        onClick: function onClick() {
          return _this2.sendEvent('minimize');
        },
        style: {
          width: 20,
          height: 20,
          margin: '28px 11px 22px 11px',
          padding: 0
        }
      }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        icon: "minimize",
        color: "black",
        size: "20px"
      })), minimized && /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
        tag: "maximize-widget",
        className: "maximize-widget",
        dataElementLocation: _taggingHelper.DataElementLocations.HEADER,
        dataElementLabel: "".concat(dataElementPrefix, "maximize-widget"),
        dataElementId: "".concat(dataElementPrefix, "maximize-widget"),
        onClick: function onClick() {
          return _this2.sendEvent('maximize');
        },
        style: {
          width: 20,
          height: 20,
          margin: '28px 11px 22px 11px',
          padding: 0
        }
      }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        icon: "web_asset",
        color: "black",
        size: "20px"
      })), /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
        tag: "open-in-new-window",
        className: "open-new-window",
        dataElementLocation: _taggingHelper.DataElementLocations.HEADER,
        dataElementLabel: "".concat(dataElementPrefix, "open-in-new-window"),
        dataElementId: "".concat(dataElementPrefix, "open-in-new-window"),
        onClick: function onClick() {
          return _this2.sendEvent('open_in_new');
        },
        style: {
          width: 20,
          height: 20,
          margin: '28px 0 22px 0',
          padding: 0
        }
      }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        icon: "open_in_new",
        color: "black",
        size: "20px"
      })), /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
        tag: "close-widget",
        className: "close-widget",
        dataElementLocation: _taggingHelper.DataElementLocations.HEADER,
        dataElementLabel: "".concat(dataElementPrefix, "close-widget"),
        dataElementId: "".concat(dataElementPrefix, "close-widget"),
        onClick: function onClick() {
          return _this2.sendEvent('close');
        },
        style: {
          width: 20,
          height: 20,
          margin: '28px 11px 22px 11px',
          padding: 0
        }
      }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        icon: "close",
        color: "black",
        size: "20px"
      })));
    }
  }]);
  return CloseIframeButton;
}(_react.Component);

var _default = CloseIframeButton;
exports["default"] = _default;